<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="products">
                    <icon name="tag"></icon> สต็อคสินค้าทั้งหมด </b-nav-item>&nbsp

                <template v-if="canInventoryProductsImport">
                    <b-nav-item router-link to="import_products">
                        <icon name="cart-arrow-down"></icon>
                        รายการนำเข้าสินค้า </b-nav-item>&nbsp
                </template>

                <template v-if="canInventoryProductsExport">
                    <b-nav-item router-link to="export_products">
                        <icon name="arrow-circle-right"></icon> รายการนำออกสินค้า
                    </b-nav-item>
                </template>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
import {
    canInventoryProductsImport,
    canInventoryProductsExport
} from "../../util/Permissions";

export default {
    name: "products",
    computed: {
        canInventoryProductsImport,
        canInventoryProductsExport
    },
}
</script>

<style scoped></style>
